module.exports = __webpack_public_path__ + "static/media/supercharge.3079ecbf.png";